package br.com.texeratx.boardgametimeapp.core.spotify.repository

import br.com.texeratx.boardgametimeapp.core.spotify.api.SpotifyDeviceDto
import br.com.texeratx.boardgametimeapp.core.spotify.api.SpotifyPlayerApi

class SpotifyPlayerRepository(
    private val api: SpotifyPlayerApi
) {
    suspend fun listDevices(): Result<List<SpotifyDeviceDto>> = api.getDevices()

    suspend fun play(spotifyUrlOrUri: String, deviceId: String): Result<Unit> =
        api.play(spotifyUrlOrUri, deviceId)
}
